import { colors } from '~/styles';

// Pure presentation helpers shared by the two time-tracking card views (TrackTimePreflight + TrackTimeResult).
// Mapping only — each view composes these into the generic ConfirmationForm.

// Per-status corner icon/color/label for a card.
const STATUS = {
  tracked: { icon: 'check-circle', color: colors.success, label: 'Logged' },
  ready: { icon: 'check-circle', color: colors.primary, label: 'Ready to log' },
  needs_info: { icon: 'exclamation-triangle', color: colors.warning, label: 'Needs info' },
  // 'ban' (forbidden), not 'lock' — in Ruddr a lock means a time entry is locked, a different concept.
  blocked: { icon: 'ban', color: colors.danger, label: 'Blocked' },
  failed: { icon: 'times-circle', color: colors.danger, label: 'Failed' },
};

export const statusMeta = (row) => STATUS[row?.status] ?? null;

// The subject column holds a project (project time) or a time off type (time off) — label it for what it
// actually holds, not the catch-all "Project / Time Off Type".
export const subjectLabel = (field, row) =>
  field.key === 'subject' ? (row?.type === 'time_off' ? 'Time Off Type' : 'Project') : field.label;
